import useSWR from 'swr';
import { logFailedRequestTiming, logRequestTiming } from './insightsHelper';

export const useModelEmi = (modelNum) => {
    const startTime = performance.now(); // Start timing
    const { data, error, isValidating, isLoading, mutate } = useSWR(
        !!modelNum ? `/api/v1/engineModel/${modelNum}/emi` : null,
        fetcher,
        {
            ...swrConfig,
            onSuccess: (_data, key) => {
                const endTime = performance.now(); // End timing
                logRequestTiming(key, Math.round(endTime - startTime));
            },
            onError: (_error, key) => {
                const endTime = performance.now(); // End timing
                logFailedRequestTiming(key, Math.round(endTime - startTime));
            }
        });

    return { data, error, isValidating, isLoading, mutate };
}

const fetcher = (url) => {
    return fetch(url)
        .then(response => response.json());
}

const swrConfig = {
    revalidateOnFocus: false,
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
        // Never retry on 4XX error.
        if (error.status >= 400 && error.status < 500) return;

        //   // Never retry for a specific key.
        //   if (key === '/api/user') return

        // Only retry up to 1 times.
        if (retryCount > 1) return;

        // Retry after 1 seconds.
        setTimeout(() => { revalidate({ retryCount }); }, 1000)
    }
};